var map = {
	"./cols1.png": 2611,
	"./cols2.png": 7000,
	"./edit.png": 9513,
	"./head.png": 8887,
	"./icon1-a.png": 54391,
	"./li.png": 50216,
	"./line-a.png": 35989,
	"./line.png": 39971,
	"./linf.png": 3112,
	"./logo.png": 22796,
	"./success.png": 43284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36801;